import {useMemo} from 'preact/hooks';

import {DeliveryEstimates, hasFasterOptions} from 'utilities/delivery-promise';

import {getScenarioCost, getScenarioVariant} from '../helpers';
import {PromiseProps} from '../types';

export function usePromiseProps(deliveryEstimates: DeliveryEstimates | null) {
  return useMemo(
    () =>
      deliveryEstimates &&
      ({
        cost: getScenarioCost(deliveryEstimates),
        variant: getScenarioVariant(deliveryEstimates),
        maxDeliveryDate: deliveryEstimates?.selectedShippingOption
          ?.maxDeliveryTime
          ? new Date(deliveryEstimates.selectedShippingOption.maxDeliveryTime)
          : null,
        daysToDelivery:
          deliveryEstimates.selectedShippingOption?.maxCalendarDaysToDelivery ??
          0,
        hasFasterOptions: hasFasterOptions(deliveryEstimates),
        timezone: deliveryEstimates?.deliveryAddress?.timezone,
      } as PromiseProps),
    [deliveryEstimates],
  );
}
